<html>
<head>
  <meta name="viewport" content="width=device-width ,initial-scale=1" />
</head>
<body style="overflow:hidden;">

  <div id="pdfTable" #pdfTable style="position:absolute; left:2000px; height: 1910px; width: 1200px;">
    <header style="height:460px;">
      <table width="1200">
        <tr>
          <td>
            <img [src]="headerPicture" width="1200" height="244" style="width:100%;height:244px;" alt="Lieferschein Kopf">
          </td>
        </tr>
        <tr>
          <td><small>&nbsp;</small></td>
        </tr>
      </table>
      <table width="1200">
        <tr>
          <td width="7%"></td>
          <td width="90%">
            <table width="100%">
              <tr>
                <td width="70%">
                  <table width="100%" style="font-size:16px;">
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                    <tr>
                      <td>&nbsp; </td>
                    </tr>
                    <tr>
                      <td style="padding-left:0px;">{{ deliveryNote.user?.firstName }} {{ deliveryNote.user?.lastName }}</td>
                    </tr>
                    <tr>
                      <td style="padding-left:0px;">{{ deliveryNote.user.address?.street }} {{ deliveryNote.user.address?.houseNumber }}</td>
                    </tr>
                    <tr>
                      <td style="padding-left:0px;">{{ deliveryNote.user.address?.postalCode }} {{ deliveryNote.user.address?.city }}</td>
                    </tr>
                  </table>
                </td>
                <td width="30%" align="left">
                  <table width="90%">
                    <tr>
                      <td colspan="2"><h4 style="margin-top:0px;margin-bottom:10px;" i18n="@@DeliverynoteTemplateHeader">LIEFERSCHEIN</h4></td>
                    </tr>
                    <tr>
                      <td style="font-size:16px;" i18n="@@DeliverynoteTemplateNumber">Lieferschein-Nr:</td>
                      <td style="font-size:16px;">{{ deliveryNote?.deliveryNoteNumber }}</td>
                    </tr>
                    <tr>
                      <td style="font-size:16px;" i18n="@@DeliverynoteTemplateCreateDate">Erstellt am:</td>
                      <td style="font-size:16px;">{{ createdAt | date }}</td>
                    </tr>
                    <tr>
                      <td style="font-size:16px;" i18n="@@DeliverynoteTemplatePage">Seiten:</td>
                      <td style="font-size:16px;">{{ pageCount }}</td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
          <td width="3%"></td>

        </tr>
      </table>

    </header>
    <main style="margin-top:50px; width:1200px; font-size:10px; height:1030px;">
      <table width="1200" style="font-size:14px;">
        <tr>
          <td width="7%"></td>
          <td width="90%">
            <table class="table">
              <tr>
                <th i18n="@@DateOfChargeTableHeader" style="padding-left:0px;">Startdatum der Ladung</th>
                <th i18n="@@MeterInitialStatusTableHeader">Zählerstand Anfang</th>
                <th i18n="@@MeterEndStatusTableHeader">Zählerstand Ende</th>
                <th i18n="@@kWhTableHeader">gelieferte kWh</th>
                <th i18n="@@ChargingStationTableHeader">Ladestation</th>
                <th i18n="@@ChargingPointTableHeader" style="text-align: right; padding-right: 0px;">Ladepunkt</th>
              </tr>
              <tr *ngFor="let transaction of transactionsOfPage.get(currentPage)">
                <td style="padding-left:0px;">{{ transaction.startTimestamp | date: 'short':'+0000' }}</td>
                <td>{{ transaction.meterStart | kwh }}</td>
                <td>{{ transaction.meterStop | kwh }}</td>
                <td>{{ transaction.meterAmount | kwh }}</td>
                <td>{{ transaction.chargingStationName }}</td>
                <td style="text-align: right; padding-right: 0px;">{{ transaction.connectorId }}</td>
              </tr>
            </table>
          </td>
          <td width="3%"></td>
        </tr>
      </table>

    </main>
    <footer style="height:160px;position:absolute;bottom:0;">

      <table width="1200" style="margin-bottom:20px;">
        <tr>
          <td width="7%"></td>
          <td width="60%" align="left" style="font-size:14px;" i18n="@@DeliverynoteTemplateTotalAmountInfoText">
            Gesamtmenge der aufgelisteten Ladevorgänge kWh: {{ kwhAmount | kwh }} | Lieferzeitraum von {{ deliveryNote.deliveryPeriodStart | date: 'shortDate'}} bis {{ deliveryNote.deliveryPeriodEnd | date: 'shortDate'}}
          </td>
          <td width="30%" align="right" style="font-size:14px;" i18n="@@DeliverynoteTemplatePageInfoText">Seite: {{currentPage }} von {{ pageCount }}</td>
          <td width="3%"></td>
        </tr>
      </table>
      <hr />
      <table width="1200">
        <tr>
          <td width="7%"></td>
          <td width="90%">
            <table width="100%">
              <tr>
                <td width="30%" style="padding-left:0px;"><img [src]="footerPicture" alt="" width="160"></td>
                <td width="30%">
                  <div style="font-size:12px; line-height:1.1;">
                    <small i18n="@@DeliverynoteTemplateCubosInfoText">
                      <b>CUBOS Service GmbH</b><br />
                      Brandgehaege 16 · 38444 Wolfsburg<br />
                      Geschäftsführung:<br />
                      Dipl.-Oec. Marc Wille
                    </small>
                  </div>
                </td>
                <td width="20%">
                  <div style="font-size:12px; line-height:1.1;">
                    <small i18n="@@DeliverynoteTemplateCubosContactInfoText">
                      <b>Tel.</b> 05308 521122-55<br />
                      <b>Fax</b> 05308 521122-01<br />
                      <b>E-Mail</b> info@cubos.com<br />
                      <b>www.cubos.com</b>
                    </small>
                  </div>
                </td>
                <td width="20%">
                  <div style="font-size:12px; line-height:1.1;">
                    <small i18n="@@DeliverynoteTemplateCubosTaxInfoText">
                      <b>Ust-Identifikation</b><br />
                      DE 317053026<br />
                      <b>Handelsregister BS</b><br />
                      HRB 207 126
                    </small>
                  </div>
                </td>
              </tr>
            </table>
          </td>
          <td width="3%"></td>
        </tr>
      </table>

    </footer>
  </div>

  <div id="pdfTableCustom" #pdfTableCustom style="position:absolute; left:2000px; height: 1910px; width: 1200px;">
    <header style="height:660px;">
      <table width="1200">
        <tr>
          <td width="7%"></td>
          <td width="90%">
            <table width="100%">
              <tr>
                <td width="70%">
                  <table width="100%" style="font-size:20px;">
                    <tr>
                      <td style="height:150px;">&nbsp;</td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                    <tr>
                      <td style="padding-left:0px;">{{ deliveryNote.user?.firstName }} {{ deliveryNote.user?.lastName }}</td>
                    </tr>
                    <tr>
                      <td style="padding-left:0px;">{{ deliveryNote.user?.address?.street }} {{ deliveryNote.user?.address?.houseNumber }}</td>
                    </tr>
                    <tr>
                      <td style="padding-left:0px;">{{ deliveryNote.user?.address?.postcode }} {{ deliveryNote.user?.address?.city }}</td>
                    </tr>
                  </table>
                </td>
                <td width="30%" align="right">
                  <table width="85%">
                    <tr>
                      <td style="height:454px;">&nbsp;</td>
                    </tr>
                    <tr>
                      <td colspan="2"><h4 style="margin-top:0px;margin-bottom:10px;" i18n="@@DeliverynoteTemplateHeader">LIEFERSCHEIN</h4></td>
                    </tr>
                    <tr>
                      <td style="font-size:16px;" i18n="@@DeliverynoteTemplateNumber">Lieferschein-Nr:</td>
                      <td style="font-size:16px;">{{ deliveryNote?.deliveryNoteNumber }}</td>
                    </tr>
                    <tr>
                      <td style="font-size:16px;" i18n="@@DeliverynoteTemplateCreateDate">Erstellt am:</td>
                      <td style="font-size:16px;">{{ createdAt | date }}</td>
                    </tr>
                    <tr>
                      <td style="font-size:16px;" i18n="@@DeliverynoteTemplatePage">Seiten:</td>
                      <td style="font-size:16px;">{{ pageCount }}</td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
          <td width="3%"></td>

        </tr>
      </table>

    </header>
    <main style="margin-top:50px; width:1200px; font-size:10px; height:850px;">
      <table width="1200" style="font-size:16px;">
        <tr>
          <td width="7%"></td>
          <td width="90%">
            <table class="table">
              <tr>
                <th i18n="@@DateOfChargeTableHeader" style="padding-left:0px;">Startdatum der Ladung</th>
                <th i18n="@@MeterInitialStatusTableHeader">Zählerstand Anfang</th>
                <th i18n="@@MeterEndStatusTableHeader">Zählerstand Ende</th>
                <th i18n="@@kWhTableHeader">gelieferte kWh</th>
                <th i18n="@@ChargingStationTableHeader">Ladestation</th>
              </tr>
              <tr *ngFor="let transaction of transactionsOfPage.get(currentPage)">
                <td style="padding-left:0px;">{{ transaction.startTimestamp | date: 'short':'+0000' }}</td>
                <td>{{ transaction.meterStart | kwh }}</td>
                <td>{{ transaction.meterStop | kwh }}</td>
                <td>{{ transaction.meterAmount | kwh }}</td>
                <td>{{ transaction.chargingStationName }}</td>
              </tr>
            </table>
          </td>
          <td width="3%"></td>
        </tr>
      </table>

    </main>
    <footer style="height:340px;position:absolute;bottom:0;">

      <table width="1200" style="margin-bottom:40px;border:none;">
        <tr>
          <td width="7%"></td>
          <td width="60%" align="left" style="font-size:18px;" i18n="@@DeliverynoteTemplateTotalAmountInfoText">
            Gesamtmenge der aufgelisteten Ladevorgänge kWh: <b>{{ kwhAmount | kwh }}</b><br />Lieferzeitraum von {{ deliveryNote.deliveryPeriodStart | date: 'shortDate'}} bis {{ deliveryNote.deliveryPeriodEnd | date: 'shortDate'}}<br />
            <b>Dieser Lieferschein wurde bereitgestellt durch CUBOS.Connect.</b>
          </td>
          <td width="30%" align="right" style="font-size:14px;" valign="top" i18n="@@DeliverynoteTemplatePageInfoText">Seite: {{currentPage }} von {{ pageCount }}</td>
          <td width="3%"></td>
        </tr>
      </table>
      <table width="1200">
        <tr>
          <td width="7%"></td>
          <td width="90%">
            &nbsp;
          </td>
          <td width="3%"></td>
        </tr>
      </table>

    </footer>
  </div>

  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header" *ngIf="loading">
        <h5 class="modal-title" i18n="@@GeneratingPdfHeader">Lieferschein wird generiert...</h5>
      </div>
      <div class="modal-body py-5">
        <div *ngIf="loading" class="loading-spinner-container">
          <div class="spinner-border text-primary loading-spinner-md" role="status">
            <span class="visually-hidden-focusable" i18n="@@GeneratingPdfHeader">Lieferschein wird generiert...</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</body>
</html>
